import { Pagination } from './Pagination';

export const WithPagination = ({id, totalItems, totalPages, pageSize, currentPage, pageSizes, labels, onPageChange, onPageSizeChange, paginationWrapper, children}) =>
{
  const wrapper = paginationWrapper ?? ((pagination) => pagination);
  return (
    <>
      {
        children
      }
      {
        wrapper(
          <Pagination id={id}
                      totalItems={totalItems}
                      totalPages={totalPages}
                      pageSize={pageSize}
                      currentPage={currentPage}
                      pageSizes={pageSizes}
                      labels={labels}
                      onPageChange={onPageChange}
                      onPageSizeChange={onPageSizeChange} />
        )
      }
    </>
  );
};
